<div class="event-container" fxLayout="column" fxLayoutGap="14px">

    <btx-breadcrumb [items]="breadcrumbItems"></btx-breadcrumb>

    <!--  -->
    <btx-title [title]="eventGroup?.name"></btx-title>


    <!--  EVENT DETAILS -->
    <div class="event-details" fxLayout="column" fxLayoutAlign="space-between end" fxFlex="100%">

        <!--  Event Description      -->
        <!-- <btx-event-description [venueName]="eventGroup?.venueName"
                               [venueCity]="eventGroup?.venueCity"
                               [startDate]="eventGroup?.firstPerformanceDate"
                               [endDate]="eventGroup?.lastPerformanceDate"
                               [venueUrl]="getVenuePageUrl()"
                               [multiDate]="true" dateFormat="mediumDate"></btx-event-description> -->

        <!-- EVENT SHARE LINK   -->
        <btx-share-button class="share-button"
                          *ngIf="config"
                          [menuTitle]="'performance.labels.shareTheEvents'|translate"
                          [title]="config.title"
                          [url]="config.url"
                          [description]="config.description"
                          [showText]="true"
                          [showIcon]="true"></btx-share-button>
    </div>

    <div class="event-media-container desktop-event-media">

        <div class="event-image" [style.backgroundColor]="color">
          <!-- <div class="mobileapp-header-container">{{eventGroup?.name}}</div> -->
            <ng-container *ngIf="eventGroup?.groupWideImage else eventImageTemplate">
                <img class="wideImage" #wideImageRef (load)="onLoadImage(wideImageRef)" src="{{getWideImage()}}" [alt]="eventGroup?.shortName">
            </ng-container>
            <ng-template #eventImageTemplate>
                <!-- <img class="" #eventImageRef (load)="onLoadImage(eventImageRef)" src="{{getGroupImage()}}" [alt]="eventGroup?.shortName"> -->
                <ng-container *ngIf="isAvifImage(eventGroup?.groupImage); else normalImage">
                  <picture >
                    <source
                      media="(max-width:649px)"
                      srcset="{{getGroupMidImage()}}"
                    />
                    <source
                      media="(min-width:650px)"
                      srcset="{{getGroupImage()}}"
                    />

                    <img
                      class="noGallery"
                      [src]="eventNoSrc"
                      loading="lazy"
                      #eventImageRef
                    (load)="onLoadImage(eventImageRef)"
                    />
                  </picture>
                </ng-container>

                <ng-template #normalImage>
                  <img
                    class=""
                    #eventImageRef
                    (load)="onLoadImage(eventImageRef)"
                    loading="lazy"
                    src="{{getGroupImage()}}"
                  />
                </ng-template>
            </ng-template>
        </div>
    </div>

    <div class="event-media-container mobile-event-media">
        <btx-share-button *ngIf="config"
                          [menuTitle]="'performance.labels.shareTheEvents'|translate"
                          [title]="config.title"
                          [url]="config.url"
                          [description]="config.description"
                          [showText]="true"
                          [showIcon]="true"></btx-share-button>

        <swiper class="mySwiper" [pagination]="true">
            <ng-template swiperSlide *ngFor="let image of mobileGallery">
              <!-- <div class="mobileapp-header-container">{{eventGroup?.name}}</div> -->
                <img swiperSlide
                    [src]="image"
                    style="width: 100%"
                    alt="">
            </ng-template>
        </swiper>
    </div>


    <section class="event-info-container">

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">

            <!-- Etkinlik Bilgileri -->
            <div class="event-info-wrapper" fxLayout="column" fxLayoutGap="10px" fxFlex="67%" fxFlex.lt-md="100%">
                <!-- <h2 class="title heading-medium" translate="performance.labels.about"></h2> -->

                <btx-read-more [text]="eventGroup?.description" [maxLength]="1000">
                </btx-read-more>
                <!--Event Sponsor Image-->
                <div class="sponsor-container" *ngIf="eventGroup.sponsorImage  && eventGroup.sponsorImage!=''">
                    <img class="sponsor-image"
                    loading="lazy"
                         [src]="eventGroup.sponsorImage|secureImage:environment.sponsorImageBasePath" alt="sponsor-image">
                </div>

                <mat-divider></mat-divider>


                <!-- Performans Listesi -->
                <div fxLayout="column">
                    <h3 class="calendar-header">{{"performance.labels.eventCalendar"|translate}}</h3>
                    <!-- <btx-event-group-list [eventCode]="eventGroup.id" [region]="region.regionName"
                                          [lang]="i18n.currentLang"></btx-event-group-list> -->

                    <div class="button-container">
                      <button
                        class="button"
                        style="border-radius: 4px 0px 0px 4px"
                        translate="performance.links.list"
                        (click)="calendarOrListStatus = false"
                        [ngStyle]="{
                          'background-color': !calendarOrListStatus ? '#026CDF' : '',
                          color: !calendarOrListStatus ? 'white' : ''
                        }"
                      ></button>
                      <button
                        class="button"
                        style="border-radius: 0px 4px 4px 0px"
                        translate="performance.links.calendar"
                        (click)="this.calendarOrListStatus = true;"
                        [ngStyle]="{
                          'background-color': calendarOrListStatus ? '#026CDF' : '',
                          color: calendarOrListStatus ? 'white' : ''
                        }"
                      >
                      </button>
                    </div>
                    <ng-container *ngIf="!calendarOrListStatus">
                        <btx-event-group-list [eventList]="eventList" [region]="region.regionName"
                                              [lang]="i18n.currentLang"></btx-event-group-list>
                    </ng-container>
                    <ng-container *ngIf="calendarOrListStatus">
                      <btx-calendar [data]="eventGroup.events" [type]="'group'"></btx-calendar>
                    </ng-container>


                </div>
                <section class="event-rules-container" id="rules" *ngIf="eventGroup.rules">
                    <h2 class="heading-medium" translate="shared.labels.eventRules"></h2>
                    <div [innerHTML]="eventGroup.rules" class="mb-2"></div>
                    <div [innerHTML]="eventGroup.info"></div>
                </section>
            </div>



            <div fxFlex class="side-image-container">
                <div class="side-image-wrapper">
                    <!-- <a *ngIf="currentLocale?.lang=='tr'" href="https://www.biletix.com/auth/TURKIYE/tr/register"><img [src]="adsImageTr" alt="register"/></a>
                    <a *ngIf="currentLocale?.lang=='en'" href="https://www.biletix.com/auth/TURKIYE/en/register"><img [src]="adsImageEn" alt="register"/></a> -->
                    <div *ngIf="eventGroup.id !== specialEventGroupId" id='div-gpt-ad-1664353181968-0' style='min-width: 300px; min-height: 600px;'></div>

                    <div *ngIf="eventGroup.id === specialEventGroupId" id='div-gpt-ad-1735133701238-0' style='min-width: 330px; min-height: 600px;'></div>
                  </div>
            </div>
        </div>
    </section>

</div>
